<template>
<v-container>
  <v-card>
    <v-card-title>
      <strong>Disposizioni</strong>
      <v-btn fab dark small color="#4EABDD" @click="insertNewRecord()">
        <v-icon dark>add</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-text-field append-icon="search" label="Cerca" single-line hide-details v-model="search"></v-text-field>
    </v-card-title>
    <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search">
      <template slot="items" slot-scope="props">
        <tr @click="updateRecord(props.item.codice)">
          <td class="text-xs-left">{{ props.item.codice }}</td>
          <td class="text-xs-left">{{ props.item.descrizione }}</td>
          <td class="text-xs-left">{{ props.item.isDisposizione1 == 1?"VERO":"FALSO"}}</td>
          <td class="text-xs-left">{{ props.item.isDisposizione2 == 1?"VERO":"FALSO" }}</td>
          <td class="text-xs-left">{{ props.item.isServiziAggiuntivi == 1?"VERO":"FALSO" }}</td>
          <td class="text-xs-left">
            <v-icon v-html="props.item.icona"></v-icon>
          </td>
        </tr>
      </template>
      <template
        slot="pageText"
        slot-scope="{ pageStart, pageStop }"
      >From {{ pageStart }} to {{ pageStop }}</template>
    </v-data-table>
  </v-card>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      search: "",
      pagination: {},
      headers: [
        { text: "Codice", align: "left", value: "codice" },
        { text: "Descrizione", align: "left", value: "descrizione" },
        { text: "Disposizione 1", align: "left", value: "isDisposizione1" },
        { text: "Disposizione 2", align: "left", value: "isDisposizione2" },
        { text: "Servizi aggiuntivi", align: "left", value: "isServiziAggiuntivi" }
      ],
      items: []
    };
  },
  created(){
    this.$store.dispatch("ImpostaScollegamento");
  },
  mounted() {
    this.CheckJWT();
    this.getDisposizioni();
  },
  methods: {
    getDisposizioni() {
      axios.get(this.$store.state.servicePath + "/api/ArDisposizionis").then(res => {
        this.items = res.data;
      });
    },
    insertNewRecord() {
      this.$router.push({ path: `/Disposizioni/0` });
    },
    updateRecord(recid) {
      this.$router.push({ path: `/Disposizioni/${recid}` });
    },
   CheckJWT() {
      axios
        .post(this.$store.state.servicePath + "/api/Login/checkJwt", {
          route: this.$route.path
        })
        .then(res => {
          if (res.data.status == "ko") {
            this.$router.push({ path: `/errore` });
          }
        })
        .catch(err =>{
          this.$router.push({ path: `/errore` });
        });
    }
  }
};
</script>